import { getStaffId } from 'data/storage';
import pinyin from 'pinyin';
import { letterPerson, Person } from 'type/contact';

export const getFirstLetterPinyin = (word: string) => {
  const pys = (pinyin(word, {
    style: pinyin.STYLE_FIRST_LETTER
  }) as string[][]);
  if (!pys || pys.length === 0) return '';

  const [firstWord] = pys[0];
  // 存在英文需要取第一个
  if (/^[a-zA-Z]/.test(firstWord)) {
    return firstWord[0].toUpperCase();
  } else {
    return '#';
  }
};

export const getLetterPerson = (personList: Person[]) => {
  const lPersons: letterPerson[] = [];
  personList.forEach(person => {
    const remark = person.remark;
    const name = person.displayName || person.realName || person.realname || person.name;
    const firstLetter = getFirstLetterPinyin(remark || name);
    const lPerson = lPersons.find(p => p.firstLetter === firstLetter);
    lPerson
      ? lPerson.person.push(person)
      : lPersons.push({ firstLetter, person: [person] });
  });
  const firstLetters = lPersons.map(p => p.firstLetter).sort();
  const hashIndex = firstLetters.findIndex((key) => key === '#');
  if (hashIndex > -1) {
    firstLetters.splice(hashIndex, 1);
    firstLetters.push('#');
  }
  const sortPersons: letterPerson[] = [];
  firstLetters.forEach(firstLetter => {
    sortPersons.push({ firstLetter, person: lPersons.find(p => p.firstLetter === firstLetter)?.person || [] });
  });
  return sortPersons;
};

export const indeterminate = (
  selectPerson: Person[],
  personList: Person[],
  disablePerson: Person[]
) => (
  !!selectPerson?.length &&
  !personList?.every(p => disablePerson?.concat(selectPerson).filter(s => p.staffId === s.staffId).length) &&
  !selectPerson?.every(s => personList?.filter(p => p.staffId !== s.staffId).length === personList.length)
);

export const checkedAll = (
  selectPerson: Person[],
  personList: Person[],
  disablePerson: Person[]
) => (
  !!selectPerson?.length &&
  personList?.every(p => disablePerson?.concat(selectPerson).filter(s => p.staffId === s.staffId).length)) ||
  personList?.every(p => disablePerson?.filter(s => p.staffId === s.staffId).length
  );

export const disabledAll = (
  personList: Person[],
  disablePerson: Person[]
) => (
  !!disablePerson?.length &&
  personList?.every(p => disablePerson?.filter(s => p.staffId === s.staffId).length)
);

export const checked = (
  staffId: string,
  selectPerson: Person[],
  disablePerson: Person[]
) => (
  !!disablePerson?.filter(c => c.staffId === staffId).length ||
  !!selectPerson?.filter(c => c.staffId === staffId).length ||
  getStaffId() === staffId
);

export const disabled = (
  staffId: string,
  disablePerson: Person[]
) => (
  !!disablePerson?.filter(c => c.staffId === staffId).length || getStaffId() === staffId
);
